<template>
    <nav class="navbar navbar-expand-md fixed-top">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item nav-main mr-0">
              <router-link to="/" class="nav-link">Misalignments</router-link> 
          </li>
        </ul>
        <ul v-if="showInfo && !bNarrowScreen" class="navbar-nav ml-auto">
          <li class="nav-item nav-secondary">
            <img
                class="align-bottom"
                :src="info"
                v-if="!bInfoVisible"
                @mouseover=fillInfo(true)  
                :style="{ 
                    cursor: 'url(' + clickCursor + '), auto'
                }"
            >
            <img
                class="align-bottom"
                :src="infosel"
                v-if="bInfoVisible"
                @mouseleave=fillInfo(false)
                :style="{ 
                    cursor: 'url(' + clickCursor + '), auto'
                }"
            >
          </li>
        </ul>
    </nav>
</template>

<script>
export default {
  name: "Navbar",
  props: ["name", "showInfo"],
  data: function() {
    return {
      info: require('@/assets/icons/info.png'),
      infosel: require('@/assets/icons/infosel.png'),
      bInfoVisible: false,
      pointerCursor: require('@/assets/cursors/magnify.svg'),
      clickCursor: require('@/assets/cursors/pointer.svg'),
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      bNarrowScreen: false
    }
  },
  methods: {
      fillInfo(bVisible) {
          this.bInfoVisible = bVisible;
          this.$emit('showInfoOverlay', bVisible);
      },
      onResize() {
          this.windowHeight = window.innerHeight;
          this.windowWidth = window.innerWidth;

          if (this.windowWidth<1000) {
            this.bNarrowScreen = true;
          }
          else {
            this.bNarrowScreen = false;
          }
      },
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}



</style>

<style>
a {
  color: white;
}
.navbar {
    height: 8vh;
    background-color: transparent;
    font-size: 3vh;
}

.nav-main {
    /* font-family: 'Figue'; */
    font-family: 'Playfair Display', serif;
}

.nav-main a:hover {
    /* text-decoration: underline; */
    /* border-bottom: 1px solid white;
    display: inline-block;
    line-height: 0.85; */
    color: white;
    cursor: url('../assets/cursors/pointer.svg'), auto;
}

.nav-secondary {
    /* font-family: 'Riposte Lazer'; */
    font-family: 'Inter Tight', sans-serif;
    font-weight: 100;
    text-transform: uppercase;
}

.nav-secondary a:hover {
    /* text-decoration: underline; */
    /* border-bottom: 1px solid white;
    display: inline-block;
    line-height: 0.85; */
    color: white;
    cursor: url('../assets/cursors/pointer.svg'), auto;
    font-weight: 800;
    text-decoration: none;

    /* background-image: linear-gradient(to bottom, white 33%, transparent 33%);
    background-position: 2em 1.51em;
    background-repeat: repeat-x;
    background-size: 1px 4px; */
}
</style>